/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 埋点-获取订单信息，主要是为埋点支付上报提供数据
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.OrderInfoDtoForIo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/getOrderByIdForIo/${orderId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
